import { message } from 'antd';
import axios from 'axios';
import { envApiUrl } from './envApiUrl';

export const deleteAllMeasurements = async (mydayId: number, refetch?: () => void) => {
  if (!mydayId) return;

  try {
    // First, get the CSRF token
    const csrfResponse = await axios.get(envApiUrl + '/auth/csrf-token', {
      withCredentials: true,
    });
    const csrfToken = csrfResponse.data.csrfToken;

    // Then make the delete request with the CSRF token
    const response = await axios.delete(envApiUrl + '/measurements/all', {
      data: { mydayId },
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken,
      },
      withCredentials: true,
    });
    console.log('deleteAllMeasurements: response: ', response);
    message.success(response.data.message || 'Successfully deleted all measurements');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('deleteAllMeasurements error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to delete all measurements');
  }
};
